import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {add, deleteAllRecords, deleteRecord, fetch, fetchRecords, swap, update,} from 'services/ApplicationsService';

import {
    deleteAllCase,
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from 'store/RecordsSliceCaseHelpers';

const entityKey = 'applications';

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
};

const normalizeRecord = (record) => {
    return Object.assign({}, record, {
        id: record.id,
    });
};

// genenrates pending, fulfilled and rejected
export const fetchApplications = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    (query) => {
        return fetchRecords(query).then((response) => {
            return response.map((record) => {
                return normalizeRecord(record);
            });
        });
    }
);

export const fetchApplication = createAsyncThunk(`${entityKey}/fetch`, (id) => {
    return fetch(id).then((response) => {
        return normalizeRecord(response);
    });
});

export const saveApplication = createAsyncThunk(
    `${entityKey}/add`,
    async (payload) => {
        return add(payload).then((response) => response);
    }
);

export const updateApplication = createAsyncThunk(
    `${entityKey}/update`,
    ({id, record}) => {
        return update(id, record).then(() => record);
    }
);

export const deleteApplication = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id) => {
        return deleteRecord(id).then(() => id);
    }
);

export const deleteAllApplications = createAsyncThunk(
    `${entityKey}/deleteAllRecords`,
    () => {
        return deleteAllRecords().then((response) => response);
    }
);

export const swapPositions = createAsyncThunk(
    `${entityKey}/swapPositions`,
    async () => {
        return swap();
    }
);

const applicationsSlice = createSlice({
                                          name: entityKey,
                                          initialState,
                                          extraReducers: (builder) => {
                                              // FETCH MANY
                                              fetchManyCase(builder, fetchApplications, entityKey);

                                              // FETCH ONE
                                              fetchOneCase(builder, fetchApplication);

                                              // SAVE ONE
                                              saveOneCase(builder, saveApplication);

                                              // UPDATE ONE
                                              updateOneCase(builder, updateApplication);

                                              // DELETE ONE
                                              deleteOneCase(builder, deleteApplication);

                                              // DELETE ALL
                                              deleteAllCase(builder, deleteAllApplications);

                                              // SWAP POSITIONS
                                              fetchManyCase(builder, swapPositions, entityKey);
                                          },
                                      });

export default applicationsSlice.reducer;
